import React from 'react'
import './LocationInfoStyles.css'

const LocationInfo = () => {
  return (
    <div className="location">
        <div className="info">
            <div className="hours">
                <h3>Hours:</h3>
                <p>​Monday - Friday:  8am - 5pm</p>
                <p>Saturdays: 12pm - 5pm</p>
                <p>Sundays: Closed</p>
                
            </div>
            <div className="address">
                <h3>Address:</h3>
                <p>1211 Hyde Park Ave <br/> Hyde Park, MA 02136</p>
            </div>
            <div className="phone">
                <h4>Phone:</h4>
                <p>+1 (617) 792-7476</p>
            </div>
        </div>
        <div className="map">
            <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=1211%20Hyde%20Park%20Ave%20Hyde%20Park,%20MA%2002136&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" title="myFrame"></iframe>
        </div>
    </div>
  )
}


export default LocationInfo